import withReferenceCounter from "./withReferenceCounter";
import nullthrows from "./nullthrows";

// These input method listeners help us design more accessible experiences for
// our users.
//
// While browser and CSS APIs provide us with methods to determine when an
// element is focused, they don’t specify the input method used to focus the
// element. Knowing the input method allows us to change an element’s
// appearance: for example, keyboard navigation often requires additional
// visual affordances (while mouse and touch navigation have built-in visual
// aids).
//
// Unfortunately, we can’t just listen to events on a per-element basis:
// while the `focus` event includes the prior target in the `relatedTarget`
// property, it does not specify the input method (which occurs as an event
// on the prior element). Since only one element can be focused at a time
// within the browser, we track the input method as global state.
var createInputMethodListeners = function createInputMethodListeners() {
  var body = function body() {
    return nullthrows(document.body);
  };

  var lastMethod = 'mouse';

  var setMethod = function setMethod(method) {
    return function () {
      lastMethod = method;
    };
  };

  var setKeyboard = setMethod('keyboard');
  var setMouse = setMethod('mouse');
  var setTouch = setMethod('touch');

  var _withReferenceCounter = withReferenceCounter({
    mount: function mount() {
      // We use the capture phase to observe all keydown, mousedown, and
      // touchstart events on the body before they’re handled by other code.
      //
      // Learn more about event bubbling and the capture phase here:
      //   https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture
      body().addEventListener('keydown', setKeyboard, true);
      body().addEventListener('mousedown', setMouse, true);
      body().addEventListener('touchstart', setTouch, true);
    },
    unmount: function unmount() {
      body().removeEventListener('keydown', setKeyboard, true);
      body().removeEventListener('mousedown', setMouse, true);
      body().removeEventListener('touchstart', setTouch, true);
    }
  }),
      mount = _withReferenceCounter.mount,
      unmount = _withReferenceCounter.unmount;

  return {
    mount: mount,
    unmount: unmount,
    getState: function getState() {
      return lastMethod;
    }
  };
};

var inputMethod = createInputMethodListeners();
export default inputMethod;